import { jsxs, jsx } from 'react/jsx-runtime';
import { useEffect, useRef } from 'react';
import Image from 'frontend-image';
import { ScriptPrint } from '@ads-placements-frontend/commons';
const VIEWABILITY_ENABLED = 'viewability-enabled';
const VIEWABILITY_BREAKING_CHANGES_VERSION = '1.0.0';
const isViewabilityLegacy = viewability => viewability && (viewability === null || viewability === void 0 ? void 0 : viewability.version) !== VIEWABILITY_BREAKING_CHANGES_VERSION;
const isViewabilityLoaded = viewability => viewability && (viewability === null || viewability === void 0 ? void 0 : viewability.getNonceToken()) !== '';
const useViewability = (ref, viewUrl, isPreview) => {
  const startViewabilitySession = () => {
    var _window$viewability;
    const session = (_window$viewability = window.viewability) === null || _window$viewability === void 0 ? void 0 : _window$viewability.addSession();
    session === null || session === void 0 || session.setMeliVaTrackUrl(viewUrl);
    session === null || session === void 0 || session.start(ref === null || ref === void 0 ? void 0 : ref.current);
  };
  useEffect(() => {
    if (isPreview || !viewUrl || !ref) {
      return () => null;
    }
    if (isViewabilityLegacy(window.viewability)) {
      var _window$viewability2;
      (_window$viewability2 = window.viewability) === null || _window$viewability2 === void 0 || _window$viewability2.addSession(ref.current, viewUrl);
      return () => null;
    }
    if (isViewabilityLoaded(window.viewability)) {
      startViewabilitySession();
      return () => null;
    }
    window.addEventListener(VIEWABILITY_ENABLED, startViewabilitySession);
    return () => {
      window.removeEventListener(VIEWABILITY_ENABLED, startViewabilitySession);
    };
  }, [ref, viewUrl, isPreview]);
};
const Advertising = props => {
  const {
    title,
    picture,
    callToAction,
    lazyLoad,
    deviceType,
    titleFirstLine,
    titleSecondLine,
    isPreview,
    tag,
    eventTracking = {
      print: [{
        url: ''
      }],
      click: [{
        url: ''
      }],
      view: [{
        url: ''
      }]
    }
  } = props;
  const LAZYLOAD = lazyLoad ? 'on' : 'off';
  const ref = useRef(null);
  const {
    print,
    view,
    click
  } = eventTracking;
  const [{
    url: clickUrl
  }] = click;
  const [{
    url: viewUrl
  }] = view;
  const [{
    url: printUrl
  }] = print;
  const namespace = tag === 'discovery-square-image' ? 'advertising-square' : 'advertising';
  useViewability(ref, viewUrl, isPreview);
  return jsxs("a", {
    ref: ref,
    className: isPreview ? "".concat(namespace, " not-active") : "".concat(namespace),
    href: clickUrl || undefined,
    children: [jsxs("div", {
      className: "".concat(namespace, "__info"),
      children: [jsx("span", {
        className: title ? "".concat(namespace, "__info--title") : "".concat(namespace, "__info--no-title"),
        children: title
      }), jsx("span", {
        className: "".concat(namespace, "__info--text ").concat(namespace, "__info--text--bold"),
        children: titleFirstLine
      }), jsx("span", {
        className: "".concat(namespace, "__info--text ").concat(namespace, "__info--text--bold"),
        children: titleSecondLine
      }), jsx("span", {
        className: deviceType === 'desktop' || deviceType === 'tablet' ? "".concat(namespace, "__info--button andes-button andes-button--small andes-button--loud") : "".concat(namespace, "__info--link"),
        children: callToAction
      })]
    }), jsx("div", {
      className: "".concat(namespace, "__image"),
      children: jsx(Image, {
        alt: titleFirstLine,
        "aria-hidden": 'true',
        lazyload: LAZYLOAD,
        src: picture
      })
    }), printUrl && jsx(ScriptPrint, {
      url: printUrl
    })]
  });
};
const Discovery = props => {
  const {
    type,
    items,
    lazyLoad,
    deviceType,
    isPreview
  } = props;
  const namespace = type || 'discovery';
  return jsx("div", {
    className: "".concat(namespace),
    children: jsx("div", {
      className: "".concat(namespace, "__body"),
      children: items.map(element => {
        const {
          content,
          event_tracking: eventTracking,
          template: {
            tag
          }
        } = element;
        const {
          texts: {
            cta: callToAction,
            secondary_title: titleSecondLine,
            primary_title: titleFirstLine,
            volanta: title
          },
          images: {
            picture
          }
        } = content;
        return jsx(Advertising, {
          title: title,
          picture: picture,
          callToAction: callToAction,
          titleFirstLine: titleFirstLine,
          titleSecondLine: titleSecondLine,
          lazyLoad: lazyLoad,
          deviceType: deviceType,
          eventTracking: eventTracking,
          isPreview: isPreview,
          tag: tag
        }, title);
      })
    })
  });
};
export { Discovery };
